import { Expose, Type } from 'class-transformer';
import { EventModel } from '../models/event.model';
import { EventCategoryModel } from '../models/event-category.model';
import { EventSubCategoryModel } from '../models/event-sub-category.model';
import { EventParticipantWithUserImpl } from './event-participant-with-user.impl';
import { EventResourceWithRelationsImpl } from './event-resource-with-relations.impl';

export class EventWithRelationsImpl extends EventModel {
  @Expose({ name: 'category' })
  @Type(() => EventCategoryModel)
  category: EventCategoryModel;
  @Expose({ name: 'sub_category' })
  @Type(() => EventSubCategoryModel)
  subCategory: EventSubCategoryModel;
  @Expose({ name: 'participants' })
  @Type(() => EventParticipantWithUserImpl)
  participants: EventParticipantWithUserImpl[];
  @Expose({ name: 'waiting_list' })
  @Type(() => EventParticipantWithUserImpl)
  waiting_list: EventParticipantWithUserImpl[];
  @Expose({ name: 'resource' })
  @Type(() => EventResourceWithRelationsImpl)
  resource: EventResourceWithRelationsImpl;
}
